import { BASE_CONFIG } from './config';

export const isAndroid = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /android/.test(ua);
};

export const isIOS = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua);
};

export const iOSVersion = () => {
  let iOSVersion = 0;
  // 提取 iOS 版本号
  const versionMatch = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (versionMatch) {
    iOSVersion = parseInt(versionMatch[1], 10);
    console.log('iOS 版本:', iOSVersion);
  }
  return iOSVersion;
};

export const isSafari = () => {
  const ua = navigator.userAgent;
  const vendor = navigator.vendor;

  // 核心判断逻辑
  return (
    // 特征1: 必须包含 'Safari' 但排除其他基于 WebKit 的浏览器
    (/safari/i.test(ua) &&
      // 特征2: 不包含 Chrome/Edge/Firefox/Opera 的标识
      !/(chrome|edge|edg|firefox|fxios|opera|opr|samsungbrowser)/i.test(ua) &&
      // 特征3: Apple 供应商标识 (Safari 独有)
      /apple/i.test(vendor) &&
      // 特征4: 验证 Safari 的版本号格式
      /version\/\d+\.\d+/i.test(ua)) ||
    // iOS/iPadOS 的 WebView 检测 (需额外处理)
    (/(iPhone|iPod|iPad).*AppleWebKit/i.test(ua) && !/(CriOS|FxiOS|OPiOS)/i.test(ua))
  );
};

export const isChrome = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf('Chrome') !== -1 && userAgent.indexOf('Google Inc') !== -1) {
    return true;
  } else {
    return false;
  }
};

export const isMobile = () => {
  return isIOS() || isAndroid();
};

export const isPWA = () => {
  // @ts-ignore
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator?.standalone ||
    document.referrer.includes('android-app://')
  );
};

export const isIosPWA = () => {
  // @ts-ignore
  return isPWA() && isIOS();
};

export const getQQChat = qqn => {
  return `https://wpa.qq.com/msgrd?v=3&uin=${qqn}&site=qq&menu=yes`;
};

export const isApp = () => {
  return (isIOS() || isAndroid()) && BASE_CONFIG.appVersion > 0;
};

export const isAppMJB = () => {
  return (isIOS() || isAndroid()) && BASE_CONFIG.appVersion === 2;
};

export const isH5 = () => {
  return isIOS() || isAndroid();
};

/**
 * @description: 获取设备信息 5-pc登录 4-H5苹果登录 3-APP苹果登录 2-H5安卓登录 1APP安卓登录
 * @param {*} isReturnIndex
 * @return {*}
 */
export const getBetPlatform = (isReturnIndex = false) => {
  // 5=PC; 7=HOMESCREEN_IOS; 6=HOMESCREEN_ANDROID; 4=H5_IOS 3=IOS 2=H5_ANDROID; 1=ANDROID 8=马甲包
  if (isAppMJB()) {
    return 'APPS_ANDROID';
  }
  if (isPWA()) {
    if (isIOS()) {
      return isReturnIndex ? 4 : 'HS_IOS';
    } else {
      return isReturnIndex ? 2 : 'HS_ANDROID';
    }
  }
  if (isAndroid()) {
    if (BASE_CONFIG.appVersion > 0) {
      return isReturnIndex ? 1 : 'ANDROID';
    } else {
      return isReturnIndex ? 2 : 'H5_ANDROID';
    }
  }
  if (isIOS()) {
    if (BASE_CONFIG.appVersion > 0) {
      return isReturnIndex ? 3 : 'IOS';
    } else {
      return isReturnIndex ? 4 : 'H5_IOS';
    }
  }
  return isReturnIndex ? 5 : 'PC';
};

export const getDeviceType = () => {
  return isH5() ? 'MWEB' : 'PC';
};

export const getChanCode = () => {
  // if (isApp()) {
  //   if (isIOS()) {
  //     return 'IOS';
  //   } else if (isAndroid()) {
  //     return 'ANDROID';
  //   }
  // }
  return 'MWEB';
};
